import { TherapistAction } from 'src/redux/actions/constant';

const initialState: object = {
  response: null,
  data: [],
  loading: false,
  error: null,
};

export const getPatientTimeSlotsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case TherapistAction.GET_PATIENT_TIME_SLOTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case TherapistAction.GET_PATIENT_TIME_SLOTS_SUCCESS:
      return {
        ...state,
        response: action.payload,
        data: action.payload || [],
        loading: false,
        error: null,
      };
    case TherapistAction.GET_PATIENT_TIME_SLOTS_FAILURE:
      return {
        ...state,
        response: action.payload,
        loading: false,
        error: action.payload,
      };
    case TherapistAction.GET_PATIENT_TIME_SLOTS_RESET:
      return initialState;
    default:
      return state;
  }
};

